import React, { useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import AnttButton from "../../../../../vendors/components/Button";
import { Checkbox } from "primereact/checkbox";
import ToastService from "../../../../../vendors/services/toastService";
import FilaContribuicaoUtil from "../../../../shared/utils/FilaContribuicaoUtil";
import { useHistory } from "react-router-dom";
import If from "../../../../../vendors/components/If";

interface Props {
  lista: any;
  codAudienciaPublica: any;
  isBlock: boolean;
  handleModalLogin: (id?: number | null) => void;
}

export default function ModalContribuirVarios({
  codAudienciaPublica,
  lista,
  isBlock,
  handleModalLogin,
}: Props) {
  const [show, setShow]: any = useState(false);
  const [checkedList, setCheckedList]: any = useState([]);
  const filteredList = lista
    .filter((m: any) => m.stPermiteContribuicao)
    .map((m: any) => m.codDispositivo);
  const history = useHistory();

  const onHide = () => {
    setShow(false);
  };

  const isChecked = (_item: any) => {
    return checkedList.indexOf(_item.codDispositivo) !== -1;
  };
  const isIdInterno = sessionStorage.getItem("idEventoInterno");

  const toPlainText = (html: string) => {
    const div = document.createElement("div");
    div.innerHTML = html ?? "";
    return div.textContent || div.innerText || "";
  };

  const item = (m: any) => {
    if (!m.stPermiteContribuicao) {
      return <></>;
    }
    const texto = toPlainText(m.dsDispositivo || "");
    return (
      <>
        <div
          className="flex flex-row align-items-center"
          style={{ margin: "20px 0" }}
        >
          <div>
            <Checkbox
              id={m.codDispositivo}
              value={m.codDispositivo}
              checked={isChecked(m)}
              onChange={() => change(m)}
            />
          </div>
          <div
            style={{
              marginLeft: "10px",
              width: "100%",
              textOverflow: "ellipsis",
            }}
          >
            <label
              onClick={() => change(m)}
              style={{ cursor: "pointer" }}
              htmlFor={m.codDispositivo}
            >
              <If condition={texto.length > 25}>
                <label>{texto.substring(0, 25)}... </label>
              </If>
              <If condition={texto.length <= 25}>
                <label>{texto}</label>
              </If>
            </label>
          </div>
        </div>
      </>
    );
  };

  const change = (m: any) => {
    const _item: any = checkedList.indexOf(m.codDispositivo);
    if (_item < 0) {
      setCheckedList([...checkedList, m.codDispositivo]);
      return;
    }
    let list = [...checkedList];
    list = list.filter((f: any) => f != m.codDispositivo);
    setCheckedList([...list]);
  };

  const confirmar = () => {
    if (isBlock) {
      handleModalLogin();
      return;
    }
    if (checkedList.length === 0) {
      ToastService.showWarn("Nenhum dispositivo selecionado.");
      return;
    }
    FilaContribuicaoUtil.setFila(checkedList);

    if (isIdInterno != null) {
      history.push("/evento-interno-contribuicao", {
        id: checkedList[0],
        codAudienciaPublica: codAudienciaPublica,
      });
    } else {
      history.push("/evento/contribuicao", {
        id: checkedList[0],
        codAudienciaPublica: codAudienciaPublica,
      });
    }
  };

  const selectAll = () => {
    if (checkedList.length != filteredList.length) {
      setCheckedList([...filteredList]);
      return;
    }
    setCheckedList([]);
  };

  return (
    <>
      <AnttButton
        className="p-button p-button-secondary"
        onClick={() => (isBlock ? handleModalLogin() : setShow(true))}
        label="Contribuir em vários tópicos"
      />
      <Dialog
        onHide={() => onHide()}
        visible={show}
        draggable={false}
        header="Selecione um ou mais tópicos para contibuir"
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              icon="pi pi-times"
              label="Cancelar"
              className="p-button-secondary"
              onClick={() => onHide()}
              style={{ backgroundColor: "blue", border: "none" }}
            />
            <Button
              icon="pi pi-check"
              label="Confirmar"
              onClick={() => {
                confirmar();
              }}
              className="finalizar-sucess"
              style={{ backgroundColor: "blue" }}
            />
          </div>
        }
      >
        <div>
          <Checkbox
            checked={checkedList.length === filteredList.length}
            id="selecionarTodos"
            onChange={() => {
              selectAll();
            }}
          />
          <label
            style={{ marginLeft: "10px", cursor: "pointer" }}
            onClick={() => {
              selectAll();
            }}
            htmlFor="selecionarTodos"
          >
            Selecionar todos
          </label>
        </div>
        {lista.map((m: any, key: any) =>
          m.dsDispositivo !== "ContribuicaoOutrosMeios" ? (
            <div key={key}>{item(m)}</div>
          ) : null
        )}
      </Dialog>
    </>
  );
}
